import React from 'react';
import {Link} from "react-router-dom";
import '../App.css';
import dco from '../images/DCO.png';
import camp from '../images/campdco.png';
import cc from '../images/crosscultural.png';
import fall from '../images/fall.jpeg';
import fig from '../images/figmabtb.jpg';
import intern from '../images/intern.png';
import spark from '../images/sparkar.png';

function Designco(props) {
  return (
    <div className="caseify">
      <div><Link to="/" id="back">(back)</Link></div>
      <div> </div>
      <div id="title">Content Strategist at Design Co</div>
      <img src={dco} alt="Content strategy at Design Co banner"/>
      <div id="table">
        <div id="tablecol">
          <div id="tablerow">
            <div id="casetitle">About</div>
            <div id="casetext">Design Co is a strong and scrappy design community at UC San Diego, bridging the gap between young designers and industry.</div>
          </div>
          <div id="tablerow">
            <div id="casetitle">Topics</div>
            <div id="casetext">Content strategy, copywriting, marketing, large-scale events, design education, pre-professional student org</div>
          </div>
        </div>
        <div id="tablecol">
          <div id="tablerow">
            <div id="casetitle">Audience</div>
            <div id="casetext">UCSD Design community, UCSD students, industry partners, UCSD Design Lab, professors, professionals, industry designers, alumni</div>
          </div>
          <div id="tablerow">
            <div id="casetitle">Timeline</div>
            <div id="casetext">Jan 2021 - March 2022</div>
          </div>
        </div>
         <div id="tablerow">
            <div id="casetitle">Responsibilities</div>
            <div id="casetext">Wrote social media and informational copy for events to get people excited about what Design Co is up to and improve the reach of our events and initiatives. 
            Created a content strategy guide to maintain consistency in copywriting and serve as a standing resource for future content strategists at Design Co.</div>
          </div>
        
      </div>

      <p>.・。.・゜✭・.・✫・゜・。.</p>

      <div id="table">
        <div id="casetitle">Event Copy</div>
        <div id="tablecol">
          <div id="tablerow">
            <img id="art" src={camp} alt="Camp DCO event graphic"/>
            <p></p>
            <p>Gather round because Camp DCo is back in town! Your itinerary is packed with workshops that dive into in-demand technical skills for UX Design, Research, Web Development, and more! Whether you’re a beginner, an expert, or someone in-between, there’s something for everyone.
            Swing by anytime from 10 AM to 4 PM on the Saturday of Week 3 (10/16) and leave with a longer skills section on your resume :) </p>
          </div>
          <div id="tablerow">
            <img id="art" src={spark} alt="Spark AR event graphic"/>
            <p></p>
            <p>Can't find any Instagram filters that spark joy? Stop by our workshop on Thursday (1/28) to learn how you can create your own Instagram filter for free! We'll guide you through our tips and tricks for Spark AR, 
            one of the most popular softwares for augmented reality experiences, and show you how user-generated content can be effective for marketing.</p>
          </div>
        </div>
        <div id="tablecol">
          <div id="tablerow">
            <img id="art" src={intern} alt="Intern panel event graphic"/>
            <p></p>
            <p>Design interns don’t do coffee runs. Instead, they’re disclosing advice you can’t find anywhere else at our annual Intern Panel. 
            Get a glimpse into their journey, application process, daily workflows, and more on the Wednesday of Week 4 (10/20) at 6:30PM!</p>
          </div>
          <div id="tablerow">
            <img id="art" src={fig} alt="Figma beyond the basics event graphic"/>
            <p></p>
            <p>Are you out of sync with Figma’s latest updates? Get back in the loop at our next GBM on Thursday, 4/29, and we’ll surf through Figma’s 
            flood of new features together! We’ll briefly review some of the basics, dive into advanced techniques, and help you sharpen your prototyping skills.</p>
          </div>
        </div>
        <div id="tablecol">
          <div id="tablerow">
            <img id="art" src={fall} alt="Fall kick-off event graphic"/>
            <p></p>
            <p>Have we met before? If not, we’re more than happy to introduce you to Design Co and our mission, board members, and upcoming events at our Fall Kick-off coming to you during Week 2.
            If you’re interested in joining the design community and previewing potential career paths like interaction design, visual design, UX research, UX engineering, 
            content strategy, and service design, join us on Zoom at 6:30 PM on Wednesday, 10/6!</p>
          </div>
          <div id="tablerow">
            <img id="art" src={cc} alt="Cross-cultural design event graphic"/>
            <p></p>
            <p>Alleviate your travel ban blues with a round trip to different design approaches across the globe! Our GBM this Thursday (1/21) will be your ticket to learn more about the importance 
            of considering different cultures and languages when designing. We'll dive into some real-world examples of projects, companies, and organizations that excel in cross-cultural design, so you won't 
            want to pass up this opportunity to gain new perspectives on how you design!</p>
          </div>
        </div>
      </div>

       <p>.・。.・゜✭・.・✫・゜・。.</p>

      <div id="tablerow">
            <div id="casetitle">Context</div>
              <p>We started in a tiny classroom in 2012. Now we're a growing community of over 200 designers. </p>

              <p>We are no strangers to the Cognitive Science department and their Design and Interaction curriculum. Call it Human-Computer Interaction (HCI), Human-Centered Design (HCD), or 
              Interactive Design. Despite UCSD’s rich history in Cognitive Science and growing interest in the Design degree, we have a problem: Design is a sliver of CogSci.</p>

              <p>Meaning, half of our efforts are devoted to interdisciplinary studies of ethnography, neuroscience, perception, data science, statistics, computing, and linguistics. 
              There’s advantages to a research-oriented degree program, but this feeds into insecurities of not feeling prepared to tackle the design industry and its evolving practices.</p>

              <p>That’s why Design Co has GBMs, large-scale events, workshops, and panels. To find resources that live beyond the classrooms and let them thrive within the hands and minds of our community.</p>

              <p2>Like any design challenge in the world, ours is to help our community members make progress towards their goals. This could look like:</p2>
              <p2>- Introducing portfolios to new students so they don’t feel overwhelmed and “behind,”</p2>
              <p2>- Sharing stories of alumni and fellow students to inspire, comfort, and connect each other,  and</p2>
              <p>- Giving students the confidence to pursue design careers that are fulfilling to them.</p>

              <p>We’re just students, so we can’t devote all of our time and efforts to grow the design community by ourselves. But, we’re also students. We bring a fresh perspective to how we interact with 
              design and use it as a tool to innovate and solve problems.</p>
      </div>

       <div id="tablerow">
            <div id="casetitle">Tone and Voice</div>
              <p>Design Co is playful, professional, and passionate.</p>
              <p>Playful because we’re also students. We’re cool with using contractions, emojis 🥰, and everyday language to communicate. Alliteration, hooks, suspense, and questions are welcomed. We echo the voices of the students, which can be excited, confused, hopeful, and curious.</p>
              <p>Professional because we want to be trusted by others, especially industry partners. We are leaders, and we want our interactions with others to make lasting impressions and lead to more opportunities for our community.</p>
              <p>Passionate because we care about the wellbeing and growth of our community. We are genuinely excited about the work we do because we believe that we can make waves within UCSD and in the greater design community.</p>
      </div>

       <p>.・。.・゜✭・.・✫・゜・。.</p>

    </div>
  );
}

export default Designco;

